// DiscordLogin.js
import React, { useState, useEffect } from 'react';

function DiscordLogin({ onLogin, onLogout }) {
  const [loading, setLoading] = useState(false);
  const [showRules, setShowRules] = useState(false);
  const [rulesAccepted, setRulesAccepted] = useState(false);
  const [agreedAt, setAgreedAt] = useState(null);

  // KORRIGIERT: Fallback-URL von http auf https geändert
  const redirectUri = `${window.location.origin}/callback`;
  const clientId = process.env.REACT_APP_DISCORD_CLIENT_ID;

  // Prüfe ob User bereits den Regeln zugestimmt hat
  useEffect(() => {
    const storedAgreedAt = localStorage.getItem('team_rules_agreed_at');
    if (storedAgreedAt) {
      setAgreedAt(parseInt(storedAgreedAt, 10));
      setRulesAccepted(true);
    }
  }, []);

  const handleAcceptRules = () => {
    const timestamp = Date.now();
    localStorage.setItem('team_rules_agreed_at', timestamp.toString());
    setAgreedAt(timestamp);
    setRulesAccepted(true);
    setShowRules(false);
  };

  const handleDiscordLogin = async () => {
    // Prüfe ob Regeln akzeptiert wurden
    if (!rulesAccepted || !agreedAt) {
      setShowRules(true);
      return;
    }

    setLoading(true);

    try {
      if (!clientId) {
        console.error('REACT_APP_DISCORD_CLIENT_ID ist nicht gesetzt');
        alert('Discord Client ID ist nicht konfiguriert (REACT_APP_DISCORD_CLIENT_ID).');
        setLoading(false);
        return;
      }

      // Einfache zufällige State für CSRF-Schutz generieren
      const randomState = Math.random().toString(36).substring(2, 15) +
                          Math.random().toString(36).substring(2, 15);

      // State im localStorage für Validierung speichern
      localStorage.setItem('discord_state', randomState);

      // Discord OAuth2 URL ohne PKCE erstellen
      const params = new URLSearchParams({
        response_type: 'code',
        client_id: clientId,
        redirect_uri: redirectUri,
        scope: 'identify guilds connections',
        state: randomState
      });

      // Direkt zu Discord für Autorisierung umleiten
      window.location.href = `https://discord.com/api/oauth2/authorize?${params.toString()}`;

    } catch (error) {
      console.error('Discord Login Error:', error);
      setLoading(false);
      alert('Fehler beim Discord Login. Bitte versuchen Sie es erneut.');
    }
  };

  // Prüfe ob Token in URL ist (Callback von Discord)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      // Token im localStorage speichern
      localStorage.setItem('discord_token', token);

      // Token aus URL entfernen
      window.history.replaceState({}, document.title, window.location.pathname);

      // Login Callback aufrufen
      onLogin();
    }
  }, [onLogin]);

  const teamRules = [
    { number: '§1', text: 'Das Ausnutzen von Rechten führt zu einem direktem Team kick, sowie eine Permanente Bewerbungssperre.' },
    { number: '§2', text: 'Jeder ist verpflichtet, freundlich und Respektvoll mit Usern im Support und zu Teammitglieder umzugehen.' },
    { number: '§3', text: 'Grundsätzlicher Eigensupport ist strengstens untersagt, dies gilt in jeglicher Hinsicht auf RP. Supportfälle in denen man selbst involviert ist, darf man nicht bearbeiten !' },
    { number: '§4', text: 'Teamler sind dazu verpflichtet Ihren Namen anzupassen => R | NAME x FRAKTION' },
    { number: '§5', text: 'Als Teammitglied hat man sich im Roleplay wie jeder andere an die Regeln zu halten, Regelbrüche die ein Teammitglied begeht, müssen der Teamverwaltung gemeldet werden. Hierbei wird mit Absprache der Teamleitung eine entsprechende Strafe festgelegt.' },
    { number: '§6', text: 'Teammitglieder dürfen keine Reallife-Kontaktdaten wie Handy-Nummern, E-Mail-Adressen etc. an Spieler oder andere Teammitglieder weitergeben, wenn nicht die Person die Reallife Daten hergeben möchte. Ebenso müssen Teammitglieder über jegliche Kommunikation außerhalb der offiziellen Wege Bescheid geben.' },
    { number: '§7', text: 'Jedes Teammitglied ist dazu verpflichtet bei Fraktions-/Organisationstreffen im RP einen Einblick zu gewähren, damit die Teamleitung Bescheid weiß.' },
    { number: '§8', text: 'Das Ansprechen von privaten Angelegenheiten, die das Team nicht betreffen, ist strengstens untersagt, dies gilt für jegliche Art von Kommunikation in Support-Tickets, Chats etc.' },
    { number: '§9', text: 'Teammitglieder dürfen keine internen Informationen weitergeben, wie z.B. Supportfälle, Internas der Teamverwaltung oder auch sonstige Internas.' },
    { number: '§10', text: 'Jedes Teammitglied muss seinen Status im Discord anpassen, wenn dieser in den Support geht: => Online oder bitte nicht Stören.' },
    { number: '§11', text: 'Alle Teammitglieder haben sich respektvoll gegenüber jedem aus dem Team zu verhalten, das beleidigen von Teammitgliedern wird nicht akzeptiert und führt zu einem direkten Teamkick.' },
    { number: '§12', text: 'Teammitglieder dürfen keine Reallife-Daten, Bilder oder Videos von anderen Personen veröffentlichen, dies gilt für jegliche Art von Kommunikation in Support-Tickets, Chats etc. Ausnahme: Die betreffende Person stimmt der Veröffentlichung zu.' },
    { number: '§13', text: 'Teammitglieder, die sich nicht an das Regelwerk halten, müssen mit Konsequenzen rechnen, wie z.B. Warn oder Teamkick.' },
    { number: '§14', text: 'Jeder hat seine Pflichten zu erfüllen. Wenn ein Support-Fall oder ein Anliegen eines Spielers offen ist, muss sich darum gekümmert werden.' },
    { number: '§15', text: 'Teammitglieder, die sich im Urlaub befinden, müssen dies im dafür vorgesehenden Channel im Discord eintragen.' },
    { number: '§16', text: 'Das Ausnutzen von Rechten, wie z.B. das Ändern von Spieler-Daten, das Einsehen von Chat-Logs etc. ist strengstens untersagt. Ausnahme: Die Teamleitung stimmt dem zu, wenn dies für den Supportfall gilt.' },
    { number: '§17', text: 'Jeder ist dazu verpflichtet, die Community zu respektieren und zu unterstützen.' },
    { number: '§18', text: 'Jedes Teammitglied ist dazu verpflichtet, bei Support-Fällen immer freundlich und hilfsbereit zu sein.' },
    { number: '§19', text: 'Jeder hat die Pflicht, bei Team-Regelbrüchen sofort der Teamleitung bescheid zu geben. Sollte diese nicht da sein, bitte ein Team Ticket öffnen' },
    { number: '§20', text: 'Wenn man auf dem Server ist, hat man im Discord zu sein.(Bereitschafts-Channel)' },
    { number: '§21', text: 'Wenn du auf dem Bereitschafts Channel bist, trägst du Sorge um dem Support Warteraum und behälst ihn im Auge.' },
    { number: '§22', text: 'Wer länger als 15 min Abwesend ist, hat den Bereitschafts Channel zu verlassen' },
    { number: '§23', text: 'Nach jeder Erstellung eines Ticket habt Ihr 48 Stunden Zeit bis Ihr den Support aufnehmt. Sollte der User innerhalb der 48 Stunden nicht seinen Support aufnehmen. Nach 48 Stunden darf dies gelöscht werden!' },
    { number: '§24', text: 'Wer den Bereitschafts Channel oder Einreise Channel nicht besetzt wenn er IC ist, bekommt ein IC Warn. Bei 2 Warns bekommt Ihr ein Teamwarn' }
  ];

  return (
    /* Der Container wurde angepasst, um den Inhalt zu zentrieren */
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      width: '100%' 
    }}>
      <button
        onClick={handleDiscordLogin}
        disabled={loading}
        style={{
          padding: '15px 30px',
          fontSize: '1.1em',
          fontWeight: 'bold',
          background: 'linear-gradient(135deg, #7289da 0%, #5b6eae 100%)',
          color: '#ffffff',
          border: 'none',
          borderRadius: '8px',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s ease',
          boxsalerno: '0 4px 15px rgba(114, 137, 218, 0.4)',
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          opacity: loading ? 0.7 : 1,
          transform: loading ? 'scale(0.98)' : 'scale(1)'
        }}
        onMouseOver={(e) => {
          if (!loading) {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxsalerno = '0 6px 20px rgba(114, 137, 218, 0.6)';
          }
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxsalerno = '0 4px 15px rgba(114, 137, 218, 0.4)';
        }}
      >
        {loading ? (
          <>
            <div style={{
              width: '20px',
              height: '20px',
              border: '2px solid transparent',
              borderTop: '2px solid #ffffff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            Lädt...
          </>
        ) : (
          <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0002 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
            </svg>
            Mit Discord anmelden
          </>
        )}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </button>

      {/* Team Rules Modal */}
      {showRules && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#2f3136',
            borderRadius: '8px',
            maxWidth: '700px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto',
            boxsalerno: '0 10px 40px rgba(0, 0, 0, 0.5)'
          }}>
            {/* Modal Header */}
            <div style={{
              backgroundColor: '#5865F2',
              color: '#ffffff',
              padding: '20px',
              borderRadius: '8px 8px 0 0',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0002 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
              </svg>
              <h3 style={{ margin: 0, fontSize: '1.3em' }}>Teamregelwerk</h3>
            </div>

            {/* Modal Body */}
            <div style={{ padding: '20px' }}>
              <div style={{
                backgroundColor: '#40444b',
                borderRadius: '8px',
                padding: '15px',
                marginBottom: '20px',
                borderLeft: '4px solid #5865F2'
              }}>
                <strong style={{ color: '#5865F2' }}>INFO</strong>
                <p style={{ margin: '10px 0 0 0', color: '#dcddde' }}>
                  Das Team Regelwerk ist stets zu Folge zu leisten. Du musst die Regeln akzeptieren, um dich anzumelden.
                </p>
              </div>

              {/* Rules List */}
              <div style={{ maxHeight: '400px', overflowY: 'auto', marginBottom: '20px' }}>
                {teamRules.map((rule) => (
                  <div key={rule.number} style={{
                    borderLeft: '3px solid #5865F2',
                    paddingLeft: '15px',
                    marginBottom: '15px',
                    backgroundColor: '#40444b',
                    borderRadius: '0 8px 8px 0',
                    padding: '12px 15px'
                  }}>
                    <h5 style={{ color: '#5865F2', margin: '0 0 5px 0', fontSize: '1em' }}>{rule.number}</h5>
                    <p style={{ color: '#dcddde', margin: 0, fontSize: '0.95em', lineHeight: '1.4' }}>{rule.text}</p>
                  </div>
                ))}
              </div>

              {/* Accept Checkbox */}
              <div style={{
                backgroundColor: '#40444b',
                borderRadius: '8px',
                padding: '15px',
                marginBottom: '20px'
              }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    id="acceptRules"
                    checked={rulesAccepted}
                    onChange={(e) => setRulesAccepted(e.target.checked)}
                    style={{
                      width: '20px',
                      height: '20px',
                      marginTop: '2px',
                      accentColor: '#5865F2',
                      cursor: 'pointer'
                    }}
                  />
                  <span style={{ color: '#dcddde', fontSize: '0.95em', lineHeight: '1.4' }}>
                    Ich habe das Teamregelwerk gelesen und akzeptiere die Regeln verbindlich.
                  </span>
                </label>
              </div>

              {/* Action Buttons */}
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button
                  onClick={() => setShowRules(false)}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: '#4f545c',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '1em',
                    fontWeight: 'bold',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#5d6269'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4f545c'}
                >
                  Abbrechen
                </button>
                <button
                  onClick={handleAcceptRules}
                  disabled={!rulesAccepted}
                  style={{
                    padding: '12px 24px',
                    backgroundColor: rulesAccepted ? '#5865F2' : '#4f545c',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: rulesAccepted ? 'pointer' : 'not-allowed',
                    fontSize: '1em',
                    fontWeight: 'bold',
                    opacity: rulesAccepted ? 1 : 0.6,
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    if (rulesAccepted) {
                      e.currentTarget.style.backgroundColor = '#4752c4';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (rulesAccepted) {
                      e.currentTarget.style.backgroundColor = '#5865F2';
                    }
                  }}
                >
                  Regeln akzeptieren & Anmelden
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DiscordLogin;